import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { path_file } from '@app/config/path-file.enum';
import { Storage, ref, uploadBytesResumable, UploadTask } from '@angular/fire/storage'
import { IFileUpload, IFileDelete, fileUploadType } from '@app/interfaces/iupload-file';
import { startWith } from 'rxjs';

declare var $: any;

@Component({
  selector: 'form-group-upload-box',
  templateUrl: './form-group-upload-box.component.html',
  styleUrls: ['./form-group-upload-box.component.css']
})
export class FormGroupUploadBoxComponent implements OnInit {

  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() messageRequired: string = '';
  @Input() type: fileUploadType = '';
  @Input() popoverContent: string = '';
  @Input() modalName: string = '';
  @Input() modalText: string = '';
  @Input() smallText: string;
  @Input() format: string = '.pdf';

  @Output() eventFileUpload = new EventEmitter<IFileUpload>();
  @Output() eventFileDelete = new EventEmitter<IFileDelete>();

  public fileName: string = '';
  public inProgress: boolean = false;
  public progressPercentaje: number = 0;

  private pathFile: string = '';

  constructor(private storage: Storage, private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.control.valueChanges
      .pipe(startWith(this.control.value))
      .subscribe((value) => {
        this.setFileValue(value);
      });

    switch (this.type) {

      case 'wwc_record':
        this.pathFile = path_file.EmployeeWwcRecord;
        break;

      case 'disability_record':
        this.pathFile = path_file.EmployeeDisabilityRecord;
        break;

      case 'criminal_record':
        this.pathFile = path_file.EmployeeCriminalRecord;
        break;

      case 'interview_report':
        this.pathFile = path_file.EmployeeInterviewReport;
        break;

      case 'interview_report_minified':
        this.pathFile = path_file.EmployeeInterviewReportMinified;
        break;

      case 'inputEducationalProject':
        this.pathFile = path_file.EmployerProject;
        break;

      case 'inputEmployeeLanguage':
        this.pathFile = path_file.EmployeeLanguage;
        break;

      case 'complaint_protocol':
        this.pathFile = path_file.ComplaintProtocol;
        break;

        case 'complaint_document':
        this.pathFile = path_file.ComplaintDocument;
        break;

        case 'employer_regulation_temp':
        this.pathFile = path_file.EmployerRegulationTemp;
        break;
    }
  }

  onClickPseudoBtn(event: PointerEvent): void {
    event.preventDefault();
    $(`#${this.id}`).click();
  }

  onSelectFile(event) {

    if (event.target.files && event.target.files[0]) {

      this.inProgress = true;
      this.progressPercentaje = 0;

      const fileNameParsed = Date.now()
        .toString()
        .concat('-', event.target.files[0].name.replace(/[^a-zA-Z0-9.]/g, ''));

      this.calculateProgressTask(
        this.uploadFile(event.target.files[0], fileNameParsed, this.pathFile),
        event.target.files[0].name
      );
    }
  }

  calculateProgressTask( uploadTask: UploadTask, fileName: string) {
    uploadTask.on(
    'state_changed',
      (snapshot) => {
        this.progressPercentaje = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        this.cd.detectChanges();
      },
      () => {

        this.inProgress = false;
        this.removeFile();
        this.cd.detectChanges();
      },
      () => {

        this.inProgress = false;
        this.fileName = fileName;
        this.control.setValue(uploadTask.snapshot.ref.name);
        this.cd.detectChanges();
        this.eventFileUpload.next({ 
	type: this.type, 
	path: uploadTask.snapshot.ref.name, 
	name: fileName });
      })
  }

  removeFile() {
    $(`#${this.id}`).val('');
    this.fileName = '';
    this.control.setValue('');
    this.cd.detectChanges();
    this.eventFileDelete.next({ type: this.type });
  }

  setFileValue(fileName: string) {
  
    if (!fileName) {
      return;
    }

    var ix = fileName.indexOf('-');
    var file = fileName;

    if (ix >= 0) {
      file = fileName.slice(ix + 1, fileName.length);
    }

    this.fileName = file === '' ? 'Eliminar' : file;
  }

  reset() {
    this.inProgress = false;
    this.progressPercentaje = 0;
    this.fileName = '';
  }

  uploadFile(file: File, _id: any, path: any) {
    const metaData = { contentType: file.type };
    const refStorage = ref(this.storage, path + _id);
    return uploadBytesResumable(refStorage, file, metaData);
  }

  onClickModalShow(event: MouseEvent) {
    event.preventDefault();
    $('#' + this.modalName).modal('show');
  }
}
